
import { addInventoryCategoryApi } from "apis/product.api";
import FormController from "pages/layout/FormController";
import { memo, useMemo, } from "react";



const InventoryCategoryFormController = function () {


    const fieldSchema = useMemo(
        () => [
            {
                title: "Name",
                placeholder: "Enter name",
                key: "name",
                type: "text",
                required: true,
                default: "",
            },
            {
                title: "Priority",
                placeholder: "Enter priority",
                key: "priority",
                type: "number",
                required: true,
                default: "",
            },
        ],
        []
    );
    return <FormController

        routeForRedirect="/inventorycategory/"
        title="inventory Category"
        inputFiedsSchema={fieldSchema}
        addFun={addInventoryCategoryApi}
        getByIdFun={() => { }}
        updateFun={() => { }}

    />
};
export default memo(InventoryCategoryFormController);
